import http from '../../http'
export default {
    get: (data) => {
        return http.post('activityservice/socialization/query', data)
    },
    update:  (data) => {
        return http.post('activityservice/socialization/update', data)
    },
    add:  (data) => {
        return http.post('activityservice/socialization/insert', data)
    }
}
